// Smaller copies of a Draksy photo for the public site. bristol keeps the original upload untouched and makes WebP
// copies at 400 / 1200 / 2000px; the attachment address takes `size=N` and returns the nearest copy >= N, or the
// original when there is none (older photos, formats it cannot resize). So an <img> can offer all three and let the
// browser choose, with `src` left as the original for anything that ignores srcset.
//
//   <img :src="url" v-bind="imgAttrs(url, '(min-width: 1024px) 50vw, 100vw')" />
//
// Only Draksy photo addresses (/media/<uuid>, or a signed attachment address in the preview) are touched; Pexels, uploads elsewhere and thumbnail/poster/download addresses
// come back with no srcset.
export const WIDTHS = Object.freeze([400, 1200, 2000]);

const ATTACHMENT = /\/api\/models\/attachment\/[0-9a-fA-F-]{36}(?:[?#]|$)/;
const OTHER_VARIANT = /[?&](thumbnail|poster)=true\b|[?&]inline=false\b|[?&]size=/;
// The public site's lasting address (src/utils/mediaUrl.js): /media/<uuid>, whole (relative or on the site's host), no query.
// Its sized copies are /media/<uuid>/<width>.webp. The studio preview still uses the signed address above.
const MEDIA = /^(?:https?:\/\/[^/?#]+)?\/media\/([0-9a-fA-F-]{36})$/;

export const canSize = (url) => typeof url === 'string' && (MEDIA.test(url) || (ATTACHMENT.test(url) && !OTHER_VARIANT.test(url)));

export function sizedUrl(url, width) {
    if (!canSize(url) || !WIDTHS.includes(width)) return url;
    if (MEDIA.test(url)) return `${url}/${width}.webp`;
    return `${url}${url.includes('?') ? '&' : '?'}size=${width}`;
}

export function srcsetOf(url) {
    if (!canSize(url)) return '';
    return WIDTHS.map((w) => `${sizedUrl(url, w)} ${w}w`).join(', ');
}

// Attributes to spread on an <img>: {srcset, sizes} or {} when the address cannot be resized.
export function imgAttrs(url, sizes = '100vw') {
    const srcset = srcsetOf(url);
    return srcset ? {srcset, sizes} : {};
}
